let _ = t => t,
  _t,
  _t2;
import { colors, fontWeights } from '@ovpn-ui/styles';
import styled from 'styled-components';
import { fontStack } from '../../styles';
export const LabelContainer = styled.div(_t || (_t = _`
    display: flex;

    justify-content: space-between;

    width: 100%;

    margin-bottom: 4px;

    ${0};

    color: ${0};

    font-weight: ${0};

    .icon-tabler-asterisk {
        margin-left: 2px;

        padding: 3px;

        color: ${0};
    }
`), fontStack.textSm, colors.neutralTextBody, fontWeights.regular, colors.brandOrange);
export const Label = styled.div(_t2 || (_t2 = _`
    font-weight: ${0};
`), fontWeights.medium);